import axios from "./axios";
export const getAgents = () => axios.get('/analyzer/v1/admin/agents');
export const createAgent = form => axios.post('/analyzer/v1/admin/agents', form);
export const updateAgent = form => axios.put('/analyzer/v1/admin/agents/' + form.id, form);
export const removeAgent = id => axios.delete('/analyzer/v1/admin/agents/' + id);
export const a2aInfo = url => axios.post('/analyzer/v1/admin/agents/a2a/info', {
  url
});
export const createA2A = url => axios.post('/analyzer/v1/admin/agents/a2a', {
  url
});
export const getTools = () => axios.get('/analyzer/v1/admin/tools');